import React from "react";
import { Button } from "@bloomberg/media.atomics";
import { TickersFilter } from "./TickersFilter";
import type { TickerItem } from "./types";
import styles from "./styles.module.css";

interface WatchlistNewsHeaderProps {
  readonly tickers: readonly TickerItem[];
  readonly allSelected: boolean;
  readonly selectedTickers: Set<string>;
  readonly onToggleTicker: (ticker: string) => void;
}

export default function WatchlistNewsHeader({
  tickers,
  allSelected,
  selectedTickers,
  onToggleTicker,
}: WatchlistNewsHeaderProps) {
  return (
    <div>
      <h2 className={styles.newsTitle}>Watchlist News</h2>
      <div className={styles.newsActionBar}>
        <div className={styles.filtersGroup}>
          <div className={styles.tickersFilterWrapper}>
            <TickersFilter
              tickers={tickers}
              allSelected={allSelected}
              selectedTickers={selectedTickers}
              onToggleTicker={onToggleTicker}
            />
          </div>
          <div className={styles.buttonsGroup}>
            <Button
              type="button"
              variant="outline"
              aria-disabled="true"
              tabIndex={-1}
              className={styles.roundedButton}
            >
              Last 24 Hours
            </Button>
            <Button
              type="button"
              variant="outline"
              aria-disabled="true"
              tabIndex={-1}
              className={styles.roundedButton}
            >
              This Week
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
